import * as Sentry from "@sentry/react";
import { LoggerContract } from "../../contracts/logger/logger";
import CONFIG from "../../core/consts/config";

const SentryLogger: LoggerContract = {
  setup: () => {
    Sentry.init({
      dsn: CONFIG.SENTRY_DSN,
      integrations: [],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    });
  },
  identify(identifier: any) {
    Sentry.setUser({ id: identifier });
  },
  Error: (error: Error, context?: any) => {
    if (context) {
      Object.keys(context).forEach((k) => {
        Sentry.setContext(k, context[k]);
      });
    }
    Sentry.captureEvent(error);
  },
};

export default SentryLogger;
